/**
 * Pure CSV serializer for the user-facing credit ledger export.
 * Mirrors the column shape of the admin Credits tab CSV so support
 * staff can diff a user's export against the admin view 1:1.
 */

export type LedgerRow = {
  created_at: string;
  kind: string;
  job_kind: string | null;
  credits: number;
  balance_after: number;
  metadata: Record<string, unknown> | null;
};

export const CREDIT_CSV_HEADER = [
  "created_at",
  "kind",
  "job_kind",
  "credits",
  "balance_after",
  "category",
  "reason",
  "stripe_session_id",
  "pack_id",
] as const;

const ESCAPE_RE = /[",\n\r]/;

export function csvEscape(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (ESCAPE_RE.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function rowsToCsv(rows: readonly LedgerRow[]): string {
  const lines = [CREDIT_CSV_HEADER.join(",")];
  for (const r of rows) {
    const m = (r.metadata ?? {}) as Record<string, unknown>;
    lines.push(
      [
        r.created_at,
        r.kind,
        r.job_kind ?? "",
        r.credits,
        r.balance_after,
        (m.category as string | undefined) ?? "",
        (m.reason as string | undefined) ?? "",
        (m.stripe_session_id as string | undefined) ?? "",
        (m.pack_id as string | undefined) ?? "",
      ]
        .map(csvEscape)
        .join(","),
    );
  }
  return lines.join("\n");
}
